// import { useTableColumnsTrazabilidad } from "@/shared";
// import Flatpickr from 'react-flatpickr';
import { gridSizeMdLg12 } from "@/shared";
import { useFetchGetRadAct } from "@/shared/actions/erp";
import { SampleTable, TabTextLabel } from "@/shared/components/ui";
import { Contrato } from "@/shared/interfaces";
// import { ITrazabilidad } from "@/shared/interfaces/erp/global/trazabilidad.interface";
import { Alert, Grid, IconButton, Tooltip } from "@mui/material";
import { Refresh } from '@mui/icons-material';
// import dayjs from "dayjs";
import { useColumnsLogConsumption } from "./useColumnsLogConsumption";
// import DateRangePicker from "@/shared/components/ui/CustomSearch/DateRangePicker";
export const VALUE_TRANSFORM = 1024 * 1024 * 1024

export type TrazabilidadLogFormTabProps = {
  contract: Contrato | any;
};

export default function TrazabilidadLogFormTab({
  contract
}: TrazabilidadLogFormTabProps) {


  // const [visualization, setVisualization] = useState("");
  // const [dateSelected, setDateSelected] = useState("");
  // const [intervalDate, setIntervalDate] = useState<Date[]>();
  // const [dataGraphical, setDataGraphical] = useState<any>();
  // const flatpickrRef = useRef<Flatpickr>(null);


  const {
    data: dataRadActivityFetched,
    isLoading: loadingRadActivity,
    isError: errorRadActivity,
    refetch: retryRadActivity,
  } = useFetchGetRadAct({
    params:{
      username:contract?.pppoe,
      per_page:5000
    },
    enabled:!!contract?.pppoe,
  })
  // useEffect(() => {
  //   // console.log(dataConsumption.filter(x=>x.acctstoptime.includes(dateSelected!)))
  //   if(!loadingRadActivity && dataRadActivityFetched?.code==200){

  //     const dataArray: any[] = dataRadActivityFetched?.data?.data

  //     // if(visualization=="INTERVALO"){
  //     //   const dataMapped = dataArray?.map((x:any)=>{
  //     //     if(typeof(x.acctstoptime)=="string" && intervalDate?.length==2){
  //     //       // console.log({val1:new Date(x.acctstoptime).getTime(), val2:intervalDate[0].getTime(), val3: intervalDate[1].getTime()})
  //     //       if(
  //     //         (new Date(x.acctstoptime).getTime()) > intervalDate[0].getTime()
  //     //         && (new Date(x.acctstoptime).getTime()) < intervalDate[1].getTime()
  //     //       ){
  //     //         console.log("se cumple para: "+x.acctstoptime)
  //     //         return {
  //     //           ...x,
  //     //           acctstoptime: formatDateWithTime(x.acctstoptime),
  //     //           acctinputoctets: parseFloat((x.acctinputoctets/VALUE_TRANSFORM).toFixed(2)),
  //     //           acctoutputoctets: parseFloat((x.acctoutputoctets/VALUE_TRANSFORM).toFixed(2)),
  //     //         }
  //     //       }
  //     //     }
  //     //   })
  //     //   console.log({dataMapped:dataMapped.filter(x=>x!==undefined)})
  //     //   setDataGraphical(
  //     //     dataMapped.filter(x=>x!==undefined)
  //     //   )

  //     // }else{
  //     //   const valueToSearch = visualization=="AÑO"? dateSelected?.slice(0,4)
  //     //     :visualization=="MES"? dateSelected?.slice(0,7)
  //     //     :dateSelected
  //     //   setDataGraphical(
  //     //     dataArray?.map((x:any)=>{
  //     //       if(typeof(x.acctstoptime)=="string"){
  //     //         if(x.acctstoptime.includes(valueToSearch!)){
  
  //     //           return {
  //     //             ...x,
  //     //             acctstoptime: formatDateWithTime(x.acctstoptime),
  //     //             acctinputoctets: parseFloat((x.acctinputoctets/VALUE_TRANSFORM).toFixed(2)),
  //     //             acctoutputoctets: parseFloat((x.acctoutputoctets/VALUE_TRANSFORM).toFixed(2)),
  //     //           }
  //     //         }
  //     //       }
  //     //     })
  //     //   )
  //     // }

      
  //   }
  // }, [dateSelected,intervalDate]);
  // useEffect(() => {
  //   setDataGraphical(
  //     dataRadActivityFetched?.data?.data
  //   )
  // }, [dataRadActivityFetched]);


  const { columnsConsumption } = useColumnsLogConsumption()
  return (
    <Grid container item {...gridSizeMdLg12} spacing={2}>
      <TabTextLabel
        text="Períodos de Consumo de Datos"
      />
      {/* <TabTextLabel
        text="Gráfica de Consumo"
      />
      <Grid item {...gridSizeMdLg6}>
        <CustomAutocompleteArrStringNoForm
          label="Visualizar por"
          options={["DIA", "MES", "AÑO", "INTERVALO"]}
          onChangeValue={(val)=>{
            setVisualization(val)
          }}
          size={gridSizeMdLg12}
        />
      </Grid>
      <Grid item {...gridSizeMdLg6}>
        {
          visualization=="INTERVALO"?
          <DateRangePicker
            flatpickrRef={flatpickrRef}
            onChange={(newValue) => 
              setIntervalDate(newValue)
            }
          />
          :
          <SampleDatePickerNoForm
            label={"Filtro de Fecha"}
            defaultValue={''}
            value=""
            views={
              visualization=="AÑO"?
              ['year']
              :visualization=="MES"?
              ['year', 'month']
              :undefined
            }
            format={
              visualization=="AÑO"?
              'YYYY'
              :visualization=="MES"?
              'YYYY-MM'
              :undefined
            }
            onChange={(val)=>setDateSelected(val)}
            // minDate={minDate ? dayjs(minDate) : null}
            maxDate={new Date()?.toISOString()}
            size={gridSizeMdLg12}
          />
        }
      </Grid> */}
      {/* <Grid container item {...gridSizeMdLg12} spacing={3}> */}
        {/* <AreaChartInternetConsumption dateSelected={dateSelected} intervalDate={intervalDate} data={dataGraphical} loading={loadingRadActivity}/> */}
      {/* </Grid> */}
      <Grid item container {...gridSizeMdLg12} width={"100%"} justifyContent={"center"}>
        {errorRadActivity ? (
          <Alert severity="warning" action={
            <Tooltip title="Reintentar consulta">
              <IconButton aria-label="Reintentar consulta" onClick={() => retryRadActivity()}>
                <Refresh />
              </IconButton>
            </Tooltip>
          }>
            No se pudo consultar el historial de consumo.
          </Alert>
        ) : <SampleTable
          columns={columnsConsumption}
          data={dataRadActivityFetched?.data?.data || []}
          enablePagination={true}
          isLoading={loadingRadActivity}
        />}

      </Grid>
    </Grid>
  );

}
